import { resolveVuetifyTheme } from '@core/utils/vuetify'
import { themeConfig } from '@themeConfig'

export const staticPrimaryColor = '#377fee'
//export const staticPrimaryColor = '#1976D2';

const theme = {
  defaultTheme: resolveVuetifyTheme(),
  themes: {
    light: {
      dark: false,
      colors: {
        'primary': localStorage.getItem(`${themeConfig.app.title}-lightThemePrimaryColor`) || staticPrimaryColor,
        'secondary': '#001B38',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'surface': '#fff',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-surface': '#2E263D',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#F4F5FA',
        'on-background': '#3A3541',
        'grey-50': '#FAFAFA',
        'grey-100': '#F0F2F8',
        'grey-200': '#EEEEEE',
        'grey-300': '#E0E0E0',
        'grey-400': '#BDBDBD',
        'grey-500': '#9E9E9E',
        'grey-600': '#757575',
        'grey-700': '#616161',
        'grey-800': '#424242',
        'grey-900': '#212121',
        'perfect-scrollbar-thumb': '#DBDADE',
        'skin-bordered-background': '#fff',
        'skin-bordered-surface': '#fff',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#3A3541',
        'overlay-scrim-opacity': 0.5,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#3A3541',
        'table-header-background': '#F9FAFC',
        'custom-background': '#F9F8F9',
        'medium-emphasis-opacity': 0.6,
        // Shadows
        'shadow-key-umbra-opacity': 'rgba(var(--v-theme-on-surface), 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(var(--v-theme-on-surface), 0.12)',
        'shadow-key-ambient-opacity': 'rgba(var(--v-theme-on-surface), 0.04)',
      },
    },
    'soft-ivory-clarity': {
      dark: false,
      colors: {
        'primary': '#2B4A6B',
        'secondary': '#6B8299',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'surface': '#fff',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-surface': '#2E263D',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#F8F1E9',
        'on-background': '#1A202C',
        'text': '#1A202C',
        'accent': '#48BB78',
        'grey-50': '#FAFAFA',
        'grey-100': '#F0F2F8',
        'grey-200': '#EEEEEE',
        'grey-300': '#E0E0E0',
        'grey-400': '#BDBDBD',
        'grey-500': '#9E9E9E',
        'grey-600': '#757575',
        'grey-700': '#616161',
        'grey-800': '#424242',
        'grey-900': '#212121',
        'perfect-scrollbar-thumb': '#DBDADE',
        'skin-bordered-background': '#fff',
        'skin-bordered-surface': '#fff',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#3A3541',
        'overlay-scrim-opacity': 0.5,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#3A3541',
        'table-header-background': '#F9FAFC',
        'custom-background': '#F9F8F9',
        'medium-emphasis-opacity': 0.6,
        // Shadows
        'shadow-key-umbra-opacity': 'rgba(var(--v-theme-on-surface), 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(var(--v-theme-on-surface), 0.12)',
        'shadow-key-ambient-opacity': 'rgba(var(--v-theme-on-surface), 0.04)',
      },
    },
    'pearl-minimalism': {
      dark: false,
      colors: {
        'primary': '#3B3B3B',
        'secondary': '#6B7280',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'surface': '#fff',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-surface': '#2E263D',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#F9FAFB',
        'on-background': '#111827',
        'text': '#111827',
        'accent': '#7C3AED',
        'grey-50': '#FAFAFA',
        'grey-100': '#F0F2F8',
        'grey-200': '#EEEEEE',
        'grey-300': '#E0E0E0',
        'grey-400': '#BDBDBD',
        'grey-500': '#9E9E9E',
        'grey-600': '#757575',
        'grey-700': '#616161',
        'grey-800': '#424242',
        'grey-900': '#212121',
        'perfect-scrollbar-thumb': '#DBDADE',
        'skin-bordered-background': '#fff',
        'skin-bordered-surface': '#fff',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#3A3541',
        'overlay-scrim-opacity': 0.5,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#3A3541',
        'table-header-background': '#F9FAFC',
        'custom-background': '#F9F8F9',
        'medium-emphasis-opacity': 0.6,
        // Shadows
        'shadow-key-umbra-opacity': 'rgba(var(--v-theme-on-surface), 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(var(--v-theme-on-surface), 0.12)',
        'shadow-key-ambient-opacity': 'rgba(var(--v-theme-on-surface), 0.04)',
      },
    },
    'linen-serenity': {
      dark: false,
      colors: {
        'primary': '#4A5568',
        'secondary': '#718096',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'surface': '#fff',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-surface': '#2E263D',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#FDF7F0',
        'on-background': '#2D3748',
        'text': '#2D3748',
        'accent': '#F6AD55',
        'grey-50': '#FAFAFA',
        'grey-100': '#F0F2F8',
        'grey-200': '#EEEEEE',
        'grey-300': '#E0E0E0',
        'grey-400': '#BDBDBD',
        'grey-500': '#9E9E9E',
        'grey-600': '#757575',
        'grey-700': '#616161',
        'grey-800': '#424242',
        'grey-900': '#212121',
        'perfect-scrollbar-thumb': '#DBDADE',
        'skin-bordered-background': '#fff',
        'skin-bordered-surface': '#fff',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#3A3541',
        'overlay-scrim-opacity': 0.5,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#3A3541',
        'table-header-background': '#F9FAFC',
        'custom-background': '#F9F8F9',
        'medium-emphasis-opacity': 0.6,
        // Shadows
        'shadow-key-umbra-opacity': 'rgba(var(--v-theme-on-surface), 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(var(--v-theme-on-surface), 0.12)',
        'shadow-key-ambient-opacity': 'rgba(var(--v-theme-on-surface), 0.04)',
      },
    },
    'cloud-blue-precision': {
      dark: false,
      colors: {
        'primary': '#2C5282',
        'secondary': '#5A8EC2',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'surface': '#fff',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-surface': '#2E263D',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#EBF4FF',
        'on-background': '#1A202C',
        'text': '#1A202C',
        'accent': '#ECC94B',
        'grey-50': '#FAFAFA',
        'grey-100': '#F0F2F8',
        'grey-200': '#EEEEEE',
        'grey-300': '#E0E0E0',
        'grey-400': '#BDBDBD',
        'grey-500': '#9E9E9E',
        'grey-600': '#757575',
        'grey-700': '#616161',
        'grey-800': '#424242',
        'grey-900': '#212121',
        'perfect-scrollbar-thumb': '#DBDADE',
        'skin-bordered-background': '#fff',
        'skin-bordered-surface': '#fff',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#3A3541',
        'overlay-scrim-opacity': 0.5,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#3A3541',
        'table-header-background': '#F9FAFC',
        'custom-background': '#F9F8F9',
        'medium-emphasis-opacity': 0.6,
        // Shadows
        'shadow-key-umbra-opacity': 'rgba(var(--v-theme-on-surface), 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(var(--v-theme-on-surface), 0.12)',
        'shadow-key-ambient-opacity': 'rgba(var(--v-theme-on-surface), 0.04)',
      },
    },
    light2: {
      dark: false,
      colors: {
        primary: '#1976D2',
        secondary: '#001B38',
        'on-secondary': '#FFFFFF',
        success: '#56CA00',
        surface: '#F4F5FA',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        background: '#FFFFFF',
        'on-background': '#3A3541',
        'grey-50': '#FAFAFA',
        'grey-100': '#F0F2F8',
        'grey-200': '#EEEEEE',
        'grey-300': '#E0E0E0',
        'grey-400': '#BDBDBD',
        'grey-500': '#9E9E9E',
        'grey-600': '#757575',
        'grey-700': '#616161',
        'grey-800': '#424242',
        'grey-900': '#212121',
        'perfect-scrollbar-thumb': '#DBDADE',
        'skin-bordered-background': '#FFF',
        'skin-bordered-surface': '#FFF',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#3A3541',
        'overlay-scrim-opacity': 0.5,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#3A3541',
        'table-header-background': '#F9FAFC',
        'custom-background': '#F9F8F9',

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(var(--v-theme-on-surface), 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(var(--v-theme-on-surface), 0.12)',
        'shadow-key-ambient-opacity': 'rgba(var(--v-theme-on-surface), 0.04)',
      },
    },
    dark: {
      dark: true,
      colors: {
        'primary': localStorage.getItem(`${themeConfig.app.title}-darkThemePrimaryColor`) || staticPrimaryColor,
        'secondary': '#8A8D93',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#111827',
        'on-background': '#F3F4F6',
        'surface': '#1F2937',
        'on-surface': '#E5E7EB',
        'grey-50': '#2A2E42',
        'grey-100': '#474360',
        'grey-200': '#4A5072',
        'grey-300': '#5E6692',
        'grey-400': '#7983BB',
        'grey-500': '#8692D0',
        'grey-600': '#AAB3DE',
        'grey-700': '#B6BEE3',
        'grey-800': '#CFD3EC',
        'grey-900': '#E7E9F6',
        'perfect-scrollbar-thumb': '#4A5072',
        'skin-bordered-background': '#312d4b',
        'skin-bordered-surface': '#312d4b',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#2C2942',
        'overlay-scrim-opacity': 0.6,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#E7E3FC',
        'table-header-background': '#3D3759',
        'custom-background': '#373452',

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(20, 18, 33, 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(20, 18, 33, 0.12)',
        'shadow-key-ambient-opacity': 'rgba(20, 18, 33, 0.04)',
      },
    },
    'midnight-blue-serenity': {
      dark: true,
      colors: {
        'primary': '#1A2B4F',
        'secondary': '#4A6FA5',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#0F172A',
        'on-background': '#E2E8F0',
        'surface': '#1A2B4F',
        'on-surface': '#E7E3FC',
        'text': '#E2E8F0',
        'accent': '#22D3EE',
        'grey-50': '#2A2E42',
        'grey-100': '#474360',
        'grey-200': '#4A5072',
        'grey-300': '#5E6692',
        'grey-400': '#7983BB',
        'grey-500': '#8692D0',
        'grey-600': '#AAB3DE',
        'grey-700': '#B6BEE3',
        'grey-800': '#CFD3EC',
        'grey-900': '#E7E9F6',
        'perfect-scrollbar-thumb': '#4A5072',
        'skin-bordered-background': '#312d4b',
        'skin-bordered-surface': '#312d4b',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#2C2942',
        'overlay-scrim-opacity': 0.6,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#E7E3FC',
        'table-header-background': '#3D3759',
        'custom-background': '#373452',

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(20, 18, 33, 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(20, 18, 33, 0.12)',
        'shadow-key-ambient-opacity': 'rgba(20, 18, 33, 0.04)',
      },
    },
    'charcoal-empathy': {
      dark: true,
      colors: {
        'primary': '#8B5CF6', // Changed from #2D2D2D to #8B5CF6 (purple)
        'secondary': '#5C6B73',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#1C2526',
        'on-background': '#D9E2EC',
        'surface': '#2D2D2D',
        'on-surface': '#E7E3FC',
        'text': '#D9E2EC',
        'accent': '#FFB4A2',
        'grey-50': '#2A2E42',
        'grey-100': '#474360',
        'grey-200': '#4A5072',
        'grey-300': '#5E6692',
        'grey-400': '#7983BB',
        'grey-500': '#8692D0',
        'grey-600': '#AAB3DE',
        'grey-700': '#B6BEE3',
        'grey-800': '#CFD3EC',
        'grey-900': '#E7E9F6',
        'perfect-scrollbar-thumb': '#4A5072',
        'skin-bordered-background': '#312d4b',
        'skin-bordered-surface': '#312d4b',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#2C2942',
        'overlay-scrim-opacity': 0.6,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#E7E3FC',
        'table-header-background': '#3D3759',
        'custom-background': '#373452',

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(20, 18, 33, 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(20, 18, 33, 0.12)',
        'shadow-key-ambient-opacity': 'rgba(20, 18, 33, 0.04)',
      },
    },
    'obsidian-precision': {
      dark: true,
      colors: {
        'primary': '#6366F1', // Changed from #18181B to #6366F1 (indigo)
        'secondary': '#3F3F46',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#09090B',
        'on-background': '#FAFAFA',
        'surface': '#18181B',
        'on-surface': '#E7E3FC',
        'text': '#FAFAFA',
        'accent': '#A5B4FC',
        'grey-50': '#2A2E42',
        'grey-100': '#474360',
        'grey-200': '#4A5072',
        'grey-300': '#5E6692',
        'grey-400': '#7983BB',
        'grey-500': '#8692D0',
        'grey-600': '#AAB3DE',
        'grey-700': '#B6BEE3',
        'grey-800': '#CFD3EC',
        'grey-900': '#E7E9F6',
        'perfect-scrollbar-thumb': '#4A5072',
        'skin-bordered-background': '#312d4b',
        'skin-bordered-surface': '#312d4b',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#2C2942',
        'overlay-scrim-opacity': 0.6,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#E7E3FC',
        'table-header-background': '#3D3759',
        'custom-background': '#373452',

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(20, 18, 33, 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(20, 18, 33, 0.12)',
        'shadow-key-ambient-opacity': 'rgba(20, 18, 33, 0.04)',
      },
    },
    'forest-night-calm': {
      dark: true,
      colors: {
        'primary': '#10B981', // Changed from #1A3C34 to #10B981 (emerald)
        'secondary': '#4A6B5C',
        'on-secondary': '#fff',
        'success': '#56CA00',
        'info': '#16B1FF',
        'warning': '#FFB400',
        'error': '#FF4C51',
        'on-primary': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#FFFFFF',
        'background': '#0C1F1B',
        'on-background': '#E6EDE9',
        'surface': '#1A3C34',
        'on-surface': '#E7E3FC',
        'text': '#E6EDE9',
        'accent': '#FFD166',
        'grey-50': '#2A2E42',
        'grey-100': '#474360',
        'grey-200': '#4A5072',
        'grey-300': '#5E6692',
        'grey-400': '#7983BB',
        'grey-500': '#8692D0',
        'grey-600': '#AAB3DE',
        'grey-700': '#B6BEE3',
        'grey-800': '#CFD3EC',
        'grey-900': '#E7E9F6',
        'perfect-scrollbar-thumb': '#4A5072',
        'skin-bordered-background': '#312d4b',
        'skin-bordered-surface': '#312d4b',
      },
      variables: {
        'code-color': '#d400ff',
        'overlay-scrim-background': '#2C2942',
        'overlay-scrim-opacity': 0.6,
        'hover-opacity': 0.04,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'border-color': '#E7E3FC',
        'table-header-background': '#3D3759',
        'custom-background': '#373452',

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(20, 18, 33, 0.08)',
        'shadow-key-penumbra-opacity': 'rgba(20, 18, 33, 0.12)',
        'shadow-key-ambient-opacity': 'rgba(20, 18, 33, 0.04)',
      },
    },
  },
}

export default theme
